export enum FeedbackRating {
  _Positive = 1,
  _Negative = -1,
}

export enum FeedbackContext {
  _ChatMessage = "CHAT_MESSAGE",
  _TranscriptText = "TRANSCRIPT_TEXT",
  _LlmTaskGeneration = "LLM_TASK_GENERATION",
}

export enum FeedbackType {
  _BadStyle = "BAD_STYLE",
  _BadStructure = "BAD_STRUCTURE",
  _BadPunctuation = "BAD_PUNCTUATION",
  _BadTimestamps = "BAD_TIMESTAMPS",
  _Incomplete = "INCOMPLETE",
  _Incorrect = "INCORRECT",
  _MissingKeyInfo = "MISSING_KEY_INFO",
  _NoAnswer = "NO_ANSWER",
  _Accurate = "ACCURATE",
  _Clear = "CLEAR",
  _WellStructured = "WELL_STRUCTURED",
  _Engaging = "ENGAGING",
  _Creative = "CREATIVE",
  _WrongSpeaker = "WRONG_SPEAKER",
  _Hallucinated = "HALLUCINATED",
  _Other = "OTHER",
}

export interface Feedback {
  id?: string;
  chatId: string;
  chatMessageId: string;
  rating: FeedbackRating;
  type?: FeedbackType;
  feedbackMessage?: string;
  context: FeedbackContext;
  source: string;
}

export interface Chat {
  id: string;
  agentId: string;
  chatAbbreviation: string;
}
